module.exports = __webpack_public_path__ + "451c4004e401b796c040b388f110e6b7.pdf";